import {ChangeDetectionStrategy, Component, DestroyRef, computed, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterLink} from '@angular/router';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import {ArrivalRangePipe} from '../../../core/pipes/arrivalRange.pipe';
import {TrackingService} from "../services/tracking.service";
import {Tour} from "../interfaces/tour.model";

@Component({
  selector: 'app-tracking-widget',
  imports: [MatProgressSpinnerModule, MatIconModule, RouterLink, MatTableModule, CommonModule, ArrivalRangePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tracking-widget.component.html',
  styleUrl: './tracking-widget.component.scss'
})
export class TrackingWidgetComponent {
  protected readonly trackingService = inject(TrackingService);

  protected readonly displayedColumns: string[] = ['tour', 'arrival', 'status'];
  protected readonly loading = this.trackingService.loading;

  protected readonly tours = computed(() =>
    this.trackingService.daysBack() === 0 ? [...this.trackingService.tours()].filter(t => t.delivered_at === null).reverse() : [],
  );

  constructor() {
    this.trackingService.daysBack.set(0);
    inject(DestroyRef).onDestroy(this.trackingService.watch());
  }

  protected checkDelay(item: Tour): string {
    if (!item) return 'time';
    const delayMinutes = item.delay_in_minutes ?? 0;
    if (delayMinutes >= 30) return 'time warning';
    if (delayMinutes > 10 && delayMinutes < 30) return 'time alerting';
    return 'time';
  }

  protected getDepartureTimeAndStation(tourId: string): string {
    const departureHour = Number(tourId.slice(0, 2)) % 24;
    const departureMin = tourId.slice(2, 4);
    const station = tourId.slice(4, 6);
    return `${departureHour.toString().padStart(2, '0')}:${departureMin}/${station}`;
  }
}
